import React, { useState } from "react";
import { AiOutlineAppstoreAdd } from "react-icons/ai";
import { Link } from "react-router-dom";
import { RoutePath } from "../../utilities/Constants";

function ClientCard({ project, user, handleSingleDelete }) {
  const { clientAdd } = RoutePath;
  const [showMore, setShowMore] = useState(false);
  const [visibility, setVisibility] = useState(true);

  const handleDelete = async () => {
    const res = await handleSingleDelete(project._id);
    if (typeof res === "boolean" && res === true) {
      setVisibility(false);
    }
  };

  return (
    <>
      {visibility ? (
        <div
          className={`group relative h-full flex flex-col justify-between bg-white dark:bg-darkModeBg dark:border-gray-600 overflow-hidden ${
            project
              ? "border border-dashed"
              : "border hover:border-secondary dark:hover:border-secondary border-dashed transition-colors duration-150"
          } rounded-lg w-full`}
        >
          {project ? (
            <>
              <div>
                <figure>
                  <img
                    src={project?.clientsImg[0]?.image}
                    alt={project?.clientsImg[0]?.name}
                    className="h-[150px] md:h-[230px] object-cover bg-center w-full"
                  />
                </figure>
                <div className="p-4 h-auto flex flex-col gap-1 justify-between">
                  <div className="w-full pb-2 transition-all duration-150">
                    <h2 className="text-lg font-semibold line-clamp-3">
                      {project?.clientsImg[0]?.name}
                    </h2>
                  </div>
                </div>
              </div>

              <div className="p-3 px-4 flex justify-between border-t border-dashed dark:border-gray-600 gap-2 text-sm md:text-base">
                <Link
                  to={`/client/${project._id}`}
                  className="btn btn-outline btn-xs border-blue-500 text-blue-500 hover:bg-blue-500 hover:border-blue-500 hover:text-white py-1.5 w-24 transition duration-150 border text-center rounded-lg"
                >
                  Edit
                </Link>
                {user === "admin" && (
                  <button
                    title="Delete"
                    id={project._id}
                    onClick={handleDelete}
                    className="btn btn-outline btn-xs border-red-500 text-red-500 hover:bg-red-500 hover:border-red-500 hover:text-white py-1.5 w-24 transition duration-150 border text-center rounded-lg"
                  >
                    Delete
                  </button>
                )}
              </div>
            </>
          ) : (
            <Link className="h-full" to={`/${clientAdd}`}>
              <div className="flex justify-center w-full h-full items-center">
                <p className="text-6xl text-gray-500 group-hover:text-secondary transition-colors duration-150">
                  <AiOutlineAppstoreAdd />
                </p>
              </div>
            </Link>
          )}
        </div>
      ) : null}
    </>
  );
}

export default ClientCard;
